enum RegApi {
  REGISTERED_PARTICIPANT_DETAIL = `protected/participant/registration/findRegistrationParticipant`,
  UPDATE_PARTICIPANT_DETAIL = `protected/participant/registration/update`,
  MAKE_PAYMENT = `protected/transaction/pay`,
  GET_BADGE_DETAILS = `protected/participant/registration/findBadgeDetails`,
  GET_TRANSACTION_REQUEST_BY_RPID_AND_POID = "protected/invoicePaymentRequest/findByRegistrationParticipantIdAndPurchaseOrderId"
}

export default RegApi;
